var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.15,
    height: 16,
    viewBox: "0 0 15.15 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12,16H6.439a3.655,3.655,0,0,1-3.551-3.743V7.579A3.655,3.655,0,0,1,6.439,3.836H12.12a3.655,3.655,0,0,1,3.551,3.743v4.678A3.655,3.655,0,0,1,12.12,16ZM6.439,5.084a2.436,2.436,0,0,0-2.367,2.5v4.678a2.436,2.436,0,0,0,2.367,2.5H12.12a2.436,2.436,0,0,0,2.367-2.5V7.579a2.436,2.436,0,0,0-2.367-2.5Zm4.47,3.368a.781.781,0,1,0-.74-.78A.761.761,0,0,0,10.909,8.452ZM1.7,10.01V3.743a2.436,2.436,0,0,1,2.367-2.5H9.753A2.338,2.338,0,0,1,11.7,2.321a.573.573,0,0,0,.824.156.645.645,0,0,0,.148-.868A3.505,3.505,0,0,0,9.753,0H4.072A3.655,3.655,0,0,0,.521,3.743V10.01a.608.608,0,0,0,.592.624A.608.608,0,0,0,1.7,10.01Zm4.573,2.178,1.456-1.611A.851.851,0,0,1,8.86,10.55l.9.776.008.006a2.013,2.013,0,0,0,1.347.52,1.908,1.908,0,0,0,1.385-.738l.013-.016.858-1.06a.647.647,0,0,0-.066-.879.571.571,0,0,0-.834.07l-.851,1.052a.689.689,0,0,1-1.115.076l-.9-.776L9.6,9.574a1.986,1.986,0,0,0-2.67.089L6.895,9.7,5.421,11.328a.648.648,0,0,0,.02.882.571.571,0,0,0,.837-.021Z",
    transform: "translate(-.521)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_copy.e362d80dae702577184baf29196842ff.svg";